import { Component } from '@angular/core'
import {
	AlertController,
	IonicPage,
	Loading,
	LoadingController,
	NavController,
	NavParams,
	ToastController
} from 'ionic-angular'


import { AuthProvider } from '../../providers/auth/auth'
import { MessageProvider } from '../../providers/message/message'
import { CondominiumProvider } from '../../providers/condominium/condominium'

import { Condominium, Message, DeviceType } from '../../models/models'
import { DeviceProvider } from '../../providers/device/device'

@IonicPage()
@Component({
	selector: 'page-message-create-report',
	templateUrl: 'message-create-report.html',
})
export class MessageCreateReportPage {
	loading: Loading
	isLoading = true;
	condominium: Condominium
	subject: string = '';
	body: string = '';

	public subjectOptions = {
		title: 'Oggetto della segnalazione',
		subTitle: 'Di cosa si tratta?',
		mode: 'md'
	};

	constructor(
		private alertCtrl: AlertController,
		private auth: AuthProvider,
		private condominiums: CondominiumProvider,
		private devices: DeviceProvider,
		private loadingCtrl: LoadingController,
		private messages: MessageProvider,
		private navCtrl: NavController,
		private navParams: NavParams,
		private toastCtrl: ToastController
	) {
		console.group('[new MessageCreateReportPage()]')
		this.condominium = <Condominium>navParams.get('condominium')
		console.groupEnd()
	}

	ionViewDidEnter() {
		let self = this
		this.isLoading = true
		this.condominiums.getById(this.condominium.id, ['administrators']).then((condominium: Condominium) => {
			self.condominium = condominium
			if(!self.condominium.administrators || self.condominium.administrators.length == 0) {
				console.log('Non si può inivare una segnalazione ad un condominio senza amministratori: ', this.condominium)
				let errorAlert = this.alertCtrl.create({
					title: 'Errore',
					subTitle: "Il condominio non ha amministratori configurati, nessuno riceverà il messaggio",
					buttons: [{
						text: 'OK',
						role: 'cancel',
						handler: () => {
							self.navCtrl.pop()
						}
					}]
				})
				errorAlert.present()
			}
			self.isLoading = false
		}).catch(error => {
			self.isLoading = false
			console.error("Errore recuperando i dati del condominio:", error)
			let toast = self.toastCtrl.create({
				message: 'Errore recuperando i dati del condominio',
				position: 'middle',
				duration: 3000,
				cssClass: "danger"
			})
			toast.present()
		})
	}

	ionViewWillUnload() {
		console.group('[MessageCreateReportPage.ionViewWillUnload()] Uscita dalla pagina')
		//se il contesto lo richiede esegue il logout in uscita
		switch(this.devices.actualType) {
			case DeviceType.DASHBOARD:
			case DeviceType.INTERCOM:
				if(this.auth.user) {
					this.auth.logout()
				}
				break
		}
		console.groupEnd()
	}


	public onModelChanged() {
		this.auth.setLogoutTimeout()
	}


	send() {
		let self = this
		this.loading = this.loadingCtrl.create({
			content: 'Invio in corso...',
			dismissOnPageChange: false
		})
		this.loading.present()

		this.messages.sendToUsers(
			this.condominium.administrators,
			this.body,
			this.subject,
			this.condominium.id).then((messages: Message[]) => {
				self.loading.dismiss()
				if(messages) {
					let toast = this.toastCtrl.create({
						message: "Segnalazione inviata all'amministrazione",
						position: 'middle',
						duration: 3000
					})
					toast.present()
					self.navCtrl.pop()
				} else {
					let errorAlert = self.alertCtrl.create({
						title: 'Errore',
						subTitle: "Impossibile inivare il messaggio in questo momento",
						buttons: ['OK']
					})
					errorAlert.present()
				}
			},
				error => {
					self.loading.dismiss()
					let errorAlert = self.alertCtrl.create({
						title: 'Errore',
						subTitle: error,
						buttons: ['OK']
					})
					errorAlert.present()
				})
	}
}



// WEBPACK FOOTER //
// ./src/pages/message-create-report/message-create-report.ts